import React from 'react';
import PropTypes from 'prop-types';

import '../layouts/not-authenticated/not-authenticated.scss';

import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';

import UnstyledHeading from '@components/shared/unstyled-heading';

import styles from './soc2-validation-display.scss';

const ValidationIcon = ({valid}) => {
  switch (valid) {
  case true:
    return (
      <CheckIcon
        titleAccess="passing"
        color="inherit"
        classes={{root: styles.pass}}
      />
    );
  case false:
    return (
      <ClearIcon
        titleAccess="failing"
        color="inherit"
        classes={{root: styles.fail}}
      />
    );
  default:
    return (
      <RadioButtonUncheckedIcon
        classes={{root: styles.pending}}
        color="inherit"
        titleAccess="pending"
      />
    );
  }
};

ValidationIcon.propTypes = {
  valid: PropTypes.bool
};

const Soc2ValidationDisplay = ({
  length,
  lower,
  upper,
  number,
  special,
  minLength = 12
}) => {
  return (
    <div className={styles.container}>
      <UnstyledHeading rank={3} className={styles.header}> Password must contain:</UnstyledHeading>
      <span className={styles.line}><ValidationIcon valid={length}/> Minimum {minLength} characters</span>
      <span className={styles.line}><ValidationIcon valid={special}/> At least one special character (!@#$%^&*)</span>
      <span className={styles.line}><ValidationIcon valid={lower}/> At least one lowercase letter (a–z)</span>
      <span className={styles.line}><ValidationIcon valid={upper}/> At least one uppercase letter (A–Z)</span>
      <span className={styles.line}><ValidationIcon valid={number}/> At least one number (0–9)</span>
    </div>
  );
};

Soc2ValidationDisplay.propTypes = {
  length: PropTypes.bool,
  lower: PropTypes.bool,
  minLength: PropTypes.number,
  number: PropTypes.bool,
  special: PropTypes.bool,
  upper: PropTypes.bool
};

export default Soc2ValidationDisplay;
